export const getDefaultDecimalSeparator = (): '.' | ',' => {
    // Example number with a decimal separator
    const num = 1.1;
    const separator = num.toLocaleString().substring(1, 2);
    return separator === '.' ? '.' : ',';
};
